'use client';

import { useRouter } from 'next/router';
import {
  useCreateSegmentFilters,
} from '@/creditflowresearch/application/PageFilters/hooks/create';
import { useEmRegionFilters } from '@/creditflowresearch/application/PageFilters/hooks/useEmRegionFilters';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useEmMarketFilters = (): IFilterSet[] => {
  const { query } = useRouter();
  const segments = useCreateSegmentFilters();
  const regions = useEmRegionFilters();

  return transformToFilterSets([
    { key: 'segments', items: segments },
    { key: 'regions', items: regions },
  ], query);
};
